import { render } from "./App.vue?vue&type=template&id=5ff0f5f2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5ff0f5f2&lang=css"
import "./App.vue?vue&type=style&index=1&id=5ff0f5f2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff0f5f2"]])

export default __exports__